import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class KPIService {
  static getMetricData(stdId, date) {
    return HttpUtil.get(
      API_ROUTES.KPI.GETMETRIC.replace("<standardId>", stdId).replace("<date>", date)
    );
  }

  static saveDataPoint(stdId, date, body) {
    return HttpUtil.post(
      API_ROUTES.KPI.SAVEDATAPOINT.replace("<standardId>", stdId).replace("<date>", date),
      body
    );
  }

  static downloadFile(stdId, date) {
    return HttpUtil.getExcelData(API_ROUTES.KPI.DOWNLOADTEMPLATE.replace("<standardId>", stdId).replace("<date>", date));
  }

  static uploadFile(formData, stdId, date) {
    return HttpUtil.post(API_ROUTES.KPI.UPLOAD.replace("<date>", date).replace("<standardId>", stdId), formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  static getMetricDataReport(standardId, metricCode, period, key) {
    return HttpUtil.get(
      API_ROUTES.ANALYTICSREPORT.GETMETRICDATA
      .replace("<standardId>", standardId)
      .replace("<metricCode>", metricCode)
      .replace("<period>", period)
      .replace("<key>", key)
    );
  }

  static getCombinedMetricDataByRange(standardId, metricCode, params) {
    return HttpUtil.get(
      API_ROUTES.ANALYTICSREPORT.GET_COMBINED_METRIC_DATA_BY_RANGE
      .replace("<standardId>", standardId)
      .replace("<metricCode>", metricCode)
      .replace("<key>", params.key)
      .replace("<periodfrom>", params.periodfrom)
      .replace("<periodto>", params.periodto)
      .replace(params.branch ? "<branch>" : "&branch=<branch>", params.branch ?? '')
    );
  }

  static exportAnalyticReport(standardId, metricCode, params) {
    return HttpUtil.getExcelData(
      API_ROUTES.ANALYTICSREPORT.GET_COMBINED_METRIC_DATA_BY_RANGE
      .replace("<standardId>", standardId)
      .replace("<metricCode>", metricCode)
      .replace("<key>", params.key)
      .replace(params.periodfrom ? "<periodfrom>" : "&periodfrom=<periodfrom>", params.periodfrom)
      .replace(params.periodto ? "<periodto>" : "&periodto=<periodto>", params.periodto)
      .replace(params.branch ? "<branch>" : "&branch=<branch>", params.branch ?? '')
    );
  }

  static getAnalyticsData(standardId, type, from, to) {
    return HttpUtil.get(
      API_ROUTES.ANALYTICSREPORT.GET_ANALYTICS
      .replace("<standardId>", standardId)
      .replace("<type>", type)
      .replace("<periodFrom>", from)
      .replace("<periodTo>", to)
    );
  }


  static exportMetricDataview(stdId, date, businessUnitIds, topicIds, categoryType, filter, showTotalReportedValue) {
    return HttpUtil.getExcelData(
      API_ROUTES.DATA_VIEW.EXPORT_METRIC_DATAVIEW_NEW
      .replace("<standardId>", stdId)
      .replace("<date>", date)
      .replace(
        businessUnitIds?.length > 0 ? "<businessUnitIds>" : "&businessUnitIds=<businessUnitIds>", 
        businessUnitIds?.length > 0 ? businessUnitIds?.toString() : ''
      )
      .replace(
        topicIds?.length > 0 ? "<topicIds>" : "&topicIds=<topicIds>", 
        topicIds?.length > 0 ? topicIds?.toString() : ''
      )
      .replace(categoryType >= 0 ? "<categoryType>" : "?categoryType=<categoryType>", categoryType >= 0 ?  categoryType : '')
      .replace(
        filter?.periodFrom && filter?.periodTo ? "<periodFrom>": "&periodFrom=<periodFrom>", 
        filter?.periodFrom && filter?.periodTo ? filter?.periodFrom : ''
      )
      .replace(
        filter?.periodFrom && filter?.periodTo ? "<periodTo>": "&periodTo=<periodTo>",
        filter?.periodFrom && filter?.periodTo ? filter?.periodTo : ''
      )
      .replace("<showTotalReportedValue>", !!showTotalReportedValue)
    );
  }

  static getImportStatus() {
    return HttpUtil.get(API_ROUTES.KPI.IMPORT_STATUS);
  }

  static createKPICategory(payload) {
    return HttpUtil.post(API_ROUTES.KPI.CATEGORY.CREATE, payload);
  }

  static updateKPICategory(payload) {
    return HttpUtil.put(API_ROUTES.KPI.CATEGORY.UPDATE, payload);
  }

  static listKPICategory(companyId) {
    return HttpUtil.get(API_ROUTES.KPI.CATEGORY.LIST.replace('<ownerId>', companyId));
  }

  static deleteKPICategory(id) {
    return HttpUtil.delete(API_ROUTES.KPI.CATEGORY.DELETE.replace('<goalCategoryId>', id));
  }

  static getKPIMetrics() {    
    return HttpUtil.get(API_ROUTES.KPI.GET_KPI_METRICS); 
  }

  static createKPIDatapoint(payload) {
    return HttpUtil.post(API_ROUTES.KPI.DATAPOINT.CREATE, payload);
  }

  static updateKPIDatapoint(payload) {
    return HttpUtil.post(API_ROUTES.KPI.DATAPOINT.UPDATE, payload);
  }

  static listKPIDatapoints(companyId) {
    return HttpUtil.get(API_ROUTES.KPI.DATAPOINT.LIST.replace('<ownerId>', companyId));
  }

  static deleteKPIDatapoint(id) {
    return HttpUtil.delete(API_ROUTES.KPI.DATAPOINT.DELETE.replace('<dataPointId>', id));
  }

  static createOrUpdateGoal(payload) {
    return HttpUtil.post(API_ROUTES.KPI.GOAL.CREATE, payload);
  }

  static listGoals(companyId, category = '') {
    return HttpUtil.get(
      API_ROUTES.KPI.GOAL.LIST
      .replace('<ownerId>', companyId)
      .replace(category ? '<category>' : '&category=<category>', category ?? '')
    );
  }

  static listGoalsPaged(companyId, type, pageNumber = 0, pageSize = 10) {
    return HttpUtil.get(
      API_ROUTES.KPI.GOAL.LIST_PAGED
      .replace('<ownerId>', companyId)
      .replace('<pageNumber>', pageNumber)
      .replace('<pageSize>', pageSize)
      .replace('<type>', type)
    );
  }

  static deleteGoal(id) {
    return HttpUtil.delete(API_ROUTES.KPI.GOAL.DELETE.replace('<goalId>', id));
  }

  static deleteGoalKPI(id) {
    return HttpUtil.delete(API_ROUTES.KPI.GOAL.DELETE_KPI.replace('<id>', id));
  }

  static deleteGoalAction(id) {
    return HttpUtil.delete(API_ROUTES.KPI.GOAL.DELETE_ACTION.replace('<id>', id));
  }

  static deleteGoalActionDP(id) {
    return HttpUtil.delete(API_ROUTES.KPI.GOAL.DELETE_DP.replace('<id>', id));
  }

  static listKPIDataPaged({
    companyId, 
    pageNumber = 0, 
    pageSize = 10, 
    period, 
    category = '', 
    goalId = '', 
    kpiId ='',
    assigneeId
  }) {
    return HttpUtil.get(
      API_ROUTES.KPI.KPI.LIST_PAGED
      .replace('<ownerId>', companyId)
      .replace('<pageNumber>', pageNumber)
      .replace('<pageSize>', pageSize)
      .replace('<period>', period)
      .replace(category ? '<category>' : '&category=<category>', category ?? '')
      .replace(goalId > 0 ? '<goalId>' : '&goalId=<goalId>', goalId > 0 ? goalId : '')
      .replace(kpiId > 0 ? '<kpiId>' : '&kpiId=<kpiId>', kpiId > 0 ? kpiId : '')
      .replace(assigneeId > 0 ? '<assigneeId>' : '&assigneeId=<assigneeId>', assigneeId > 0 ? assigneeId : '')
    );
  }

  static upsertKPIData(payload) {
    return HttpUtil.post(API_ROUTES.KPI.KPI.UPSERT, payload);
  }

  static upsertKPI(payload, goalId) {
    return HttpUtil.post(API_ROUTES.KPI.KPI.UPSERT_KPI.replace('<goalId>', goalId), payload);
  }

  static getKPIs(goalId) {
    return HttpUtil.get(API_ROUTES.KPI.KPI.GET_KPIS.replace('<goalId>', goalId));
  }

  static deleteKPI(kpiId) {
    return HttpUtil.delete(API_ROUTES.KPI.KPI.DELETE_KPI.replace('<kpiId>', kpiId));
  }

  static upsertAction(payload, kpiId) {
    return HttpUtil.post(API_ROUTES.KPI.ACTION.UPSERT.replace('<kpiId>', kpiId), payload);
  }

  static getActions(kpiId) {
    return HttpUtil.get(API_ROUTES.KPI.ACTION.GET.replace('<kpiId>', kpiId));
  }

  static deleteAction(actionId) {
    return HttpUtil.delete(API_ROUTES.KPI.ACTION.DELETE.replace('<actionId>', actionId));
  }

  static filterActions({
    ownerId,
    category,
    goalId,
    kpiId,
    assigneeId
  }) {
    return HttpUtil.get(
      API_ROUTES.KPI.ACTION.FILTER
      .replace('<ownerId>', ownerId)
      .replace(category ? '<category>' : '&category=<category>', category ?? '')
      .replace(goalId ? '<goalId>' : '&goalId=<goalId>', goalId ?? '')
      .replace(kpiId ? '<kpiId>' : '&kpiId=<kpiId>', kpiId ?? '')
      .replace(assigneeId ? '<assigneeId>' : '&assigneeId=<assigneeId>', assigneeId ?? '')
    );
  }

  static upsertActionProgress(payload, actionId) {
    return HttpUtil.post(API_ROUTES.KPI.ACTION.UPSERT_PROGRESS.replace('<actionId>', actionId), payload);
  }

  static getActionProgress(actionId) {
    return HttpUtil.get(API_ROUTES.KPI.ACTION.GET_PROGRESS.replace('<actionId>', actionId));
  }

  static deleteActionProgress(progressId) {
    return HttpUtil.delete(API_ROUTES.KPI.ACTION.DELETE_PROGRESS.replace('<progressId>', progressId));
  }

  static getGraphByGoal(ownerId, period, goalId) {
    return HttpUtil.get(
      API_ROUTES.KPI.GRAPH.GET_BY_GOAL
      .replace('<goalId>', goalId)
      .replace('<period>', period)
      .replace('<ownerId>', ownerId)
    );
  }

  static getGraphByKPI(ownerId, period, kpiId) {
    return HttpUtil.get(
      API_ROUTES.KPI.GRAPH.GET_BY_KPI
      .replace('<kpiId>', kpiId)
      .replace('<period>', period)
      .replace('<ownerId>', ownerId)
    );
  }

  static getActionsForGraph(ownerId, goalId, period, kpiId = '', businessUnitId = '') {
    return HttpUtil.get(
      API_ROUTES.KPI.GRAPH.GET_ACTIONS
      .replace('<goalId>', goalId)
      .replace('<period>', period)
      .replace('<ownerId>', ownerId)
      .replace(kpiId ? '<kpiId>' : '&kpiId=<kpiId>', kpiId ?? '')
      .replace(businessUnitId ? '<businessUnitId>' : '&businessUnitId=<businessUnitId>', businessUnitId ?? '')
    );
  }

  static exportMetricDataAttachments(stdId, date, businessUnitIds, topicIds, categoryType) {
    return HttpUtil.getExcelData(
      API_ROUTES.DATA_VIEW.EXPORT_METRIC_DATA_ATTACHMENTS
      .replace("<standardId>", stdId)
      .replace("<date>", date)
      .replace(
        businessUnitIds?.length > 0 ? "<businessUnitIds>" : "businessUnitIds=<businessUnitIds>", 
        businessUnitIds?.length > 0 ? businessUnitIds?.toString() : ''
      )
      .replace(
        topicIds?.length > 0 ? "<topicIds>" : "&topicIds=<topicIds>", 
        topicIds?.length > 0 ? topicIds?.toString() : ''
      )
      .replace("<categoryType>", categoryType)
    );
  }

  static downloadMetricDataTemplate(stdId, date, businessUnitIds, topicIds, categoryType, filter) {
    return HttpUtil.get(
      API_ROUTES.DATA_VIEW.EXPORT_METRIC_DATAVIEW
      .replace("<standardId>", stdId)
      .replace("<date>", date)
      .replace(
        businessUnitIds?.length > 0 ? "<businessUnitIds>" : "&businessUnitIds=<businessUnitIds>", 
        businessUnitIds?.length > 0 ? businessUnitIds?.toString() : ''
      )
      .replace(
        topicIds?.length > 0 ? "<topicIds>" : "&topicIds=<topicIds>", 
        topicIds?.length > 0 ? topicIds?.toString() : ''
      )
      .replace(categoryType >= 0 ? "<categoryType>" : "?categoryType=<categoryType>", categoryType >= 0 ?  categoryType : '')
      .replace(
        filter?.periodFrom && filter?.periodTo ? "<periodFrom>": "&periodFrom=<periodFrom>", 
        filter?.periodFrom && filter?.periodTo ? filter?.periodFrom : ''
      )
      .replace(
        filter?.periodFrom && filter?.periodTo ? "<periodTo>": "&periodTo=<periodTo>", 
        filter?.periodFrom && filter?.periodTo ? filter?.periodTo : ''
      )
    );
  }

}